//src/constants/complaintTypes.js

export const COMPLAINT_TYPES = [
  { id: "wrong_deduction", labelEn: "Wrong Deduction",            labelRu: "Galat Deduction",        icon: "💸" },
  { id: "no_consent",      labelEn: "Subscribed Without Consent", labelRu: "Bina Izazat Subscribe",  icon: "🚫" },
  { id: "claim_rejected",  labelEn: "Claim Rejected",             labelRu: "Claim Reject Hua",       icon: "❌" },
  { id: "slow_support",    labelEn: "Slow Support",               labelRu: "Support Dheema Tha",     icon: "🐢" },
  { id: "service_issue",   labelEn: "Service Issue",              labelRu: "Service Mein Masla",     icon: "⚙️" },
  { id: "other",           labelEn: "Other Issue",                labelRu: "Koi Aur Masla",          icon: "📝" },
];